import type { GetStaticPaths, GetStaticProps, NextPage } from 'next'

import { StoryPage, StoryPageProps } from 'src/App/StoryPage/StoryPage'
import { strapiGetStories } from 'src/strapi/api/getStories'
import { strapiClient } from 'src/strapi/client'
import { StoryClientType } from 'src/strapi/types/storiesTypes'
import { StrapiResponseWithPagination } from 'src/strapi/types/strapiTypes'

const Story: NextPage<StoryPageProps> = (props) => (
  <StoryPage key={props.story.slug} {...props} />
)

function pickRandomStories(
  stories: Array<StoryClientType>,
  alreadyChosenStorySlug: string
) {
  const randomStories = stories
    .sort(() => 0.5 - Math.random())
    .filter(({ slug }) => slug !== alreadyChosenStorySlug)
    .slice(0, 3)

  return randomStories
}

export const getStaticProps: GetStaticProps<StoryPageProps> = async (ctx) => {
  const slug = ctx.params?.slug
  let story = {} as StoryClientType

  const recommendedStories: Array<StoryClientType> = []

  try {
    const storyResp = await strapiClient.get<
      StrapiResponseWithPagination<StoryClientType>
    >(
      `/stories?filters[slug][$eqi]=${slug}&populate=company_logo&populate=photo`
    )
    story = storyResp.data.data[0].attributes

    const stories = await strapiGetStories({
      withImages: true,
    })
    recommendedStories.push(...pickRandomStories(stories, story.slug))

    if (!story) {
      throw new Error()
    }
  } catch (error) {
    console.log('Failed to create page stories/[slug]', error)
  }

  return {
    revalidate: false,
    props: {
      story,
      recommendedStories,
    },
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const stories: Array<StoryClientType> = []

  try {
    const strapiStories = await strapiGetStories()

    if (!strapiStories.length) {
      throw new Error()
    }

    stories.push(...strapiStories)
  } catch (error) {
    throw new Error(
      'Failed to build paths for page stories/[slug]',
      error as Error
    )
  }

  const paths = stories.map((article) => ({
    params: {
      slug: article.slug,
    },
  }))

  return {
    paths,
    fallback: false,
  }
}

export default Story
